import React from 'react';

import { StyledButton, StyledButtonBlock } from './styled';

const FaqButton = () => (
  <StyledButtonBlock>
    <StyledButton>?</StyledButton>
  </StyledButtonBlock>
);

export default FaqButton;
